<template>
    <div :class="{section: true, poll: true, mobile: mobile()}">
        <img class="moon" src="@/assets/christmas/moon2.svg">
        <img class="grass" src="@/assets/christmas/grass2.svg">
        <img class="stone" src="@/assets/christmas/stone.svg">
        <div class="ground"></div>
        <div v-show="! finished" :class="{questionContainer: true, expanded: expandText}">
            <h1 class="question">Was denkst du,<br>wer war Jesus?</h1>
            <ul class="radios">
                <Radio value="Stallbursche" :selectedValue="selection" @select="onSelect">Stallbursche</Radio>
                <Radio value="jüdischer Wanderprediger" :selectedValue="selection" @select="onSelect">jüdischer
                    Wanderprediger
                </Radio>
                <Radio value="Retter der Welt" :selectedValue="selection" @select="onSelect">Retter der Welt</Radio>
                <Radio value="__own" :selectedValue="selection" @select="onSelect">
                    <textarea v-model="text" :class="{textarea: true, selected: expandText}"
                              placeholder="etwas anderes..." @click="expandText = true"></textarea>
                </Radio>

            </ul>
            <div :class="{cButton: true, disabled: buttonDisabled()}" @click="submit()">Weiter</div>
        </div>
        <div v-show="finished" id="pollThanks" class="thanks">
            <h2>Vielen Dank!<br>WERSGLAUBT wünscht</h2>
            <h1>Frohe Weihnachten!</h1>
            <div v-show="! chatSubmitted" class="chat">
                <h3>Möchtest du mit uns drüber reden?</h3>
                <textarea v-model="chat">

                </textarea>
                <label for="chatName">Vorname</label>
                <input v-model="name" id="chatName" type="text">
                <label for="chatEmail">E-Mail</label>
                <input v-model="email" id="chatEmail" type="email">
            </div>
            <h3 v-show="chatSubmitted" class="chatThanks">
                Danke für deine Nachricht! Wir werden uns so bald wie möglich bei dir melden.
            </h3>
            <div class="buttons">
                <div v-show="! chatSubmitted"
                     :class="{cButton: true, submitButton: true, disabled: ! isEverythingValid()}"
                     @click="submitChat()">Abschicken
                </div>
                <div class="cButton closeButton" @click="close()">Zur klassischen Website</div>
            </div>
        </div>

    </div>
</template>

<script>
    import Vue from 'vue'
    import Component from 'vue-class-component'
    import BasicComponent from "@/components/BasicComponent";
    import Radio from "@/components/christmas/Radio";
    import axios from "axios";
    import Fingerprint2 from 'fingerprintjs2';

    @Component({
        components: {Radio}
    })
    export default class Poll extends BasicComponent {

        data() {
            return {
                selection: null,
                text: "",
                expandText: false,
                finished: false,
                chat: "",
                name: "",
                email: "",
                chatSubmitted: false,
                fingerprint: null
            };
        }

        onActive() {

        }

        created() {
            new Fingerprint2({detectScreenOrientation: false}).get(this.onFingerprintReady);
        }

        onFingerprintReady(result) {
            this.$data.fingerprint = result;
        }

        mounted() {
            this.register();
        }

        onSelect(value) {
            this.$data.selection = value;
            this.trackEvent('Weihnachten - Meinung ausgewählt', value);
        }

        buttonDisabled() {
            return this.$data.selection === null || (this.$data.selection === "__own" && this.$data.text.trim() === "");
        }

        getOpinion() {
            let selection = this.$data.selection;
            if (selection === "__own") selection = this.$data.text;
            return selection;
        }

        submit() {
            if (this.buttonDisabled()) return;

            this.trackEvent('Weihnachten - Meinung abgeschickt', this.getOpinion());

            axios.post("/opinion.php", {
                "fingerprint": this.$data.fingerprint,
                "opinion": this.$data.selection,
                "opinion_text": this.$data.selection === "__own" ? this.$data.text : null
            }).then((response) => {

            }).catch((err) => {
                this.error = true;
                console.error(err);
            });

            this.$data.finished = true;
            this.$data.chat = this.getChatText();
        }

        submitChat() {
            if (!this.isEverythingValid()) return;

            axios.post("/contact.php", {
                "token": "",
                "email": this.email,
                "name": this.name,
                "text": this.chat
            }).then((response) => {
                this.$data.chatSubmitted = true;
            }).catch((err) => {
                this.error = true;
                alert("Ein unbekannter Fehler ist aufgetreten. Bitte sende deine Anfrage per Mail an kontakt@wersglaubt.at. Danke für dein Verständnis!");
                console.error(err);
            });

        }

        close() {
            this.$emit("close");
        }

        getChatText() {
            return "Meiner Meinung nach war Jesus:\n" + this.getOpinion() + "\n"
        }

        isEmailValid(email) {
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        }

        isValid(text) {
            return text && text.trim().length > 0
        }

        isEverythingValid() {
            return this.isValid(this.getChatText()) && this.isValid(this.name) && this.isValid(this.email) && this.isEmailValid(this.email);
        }

    }
</script>
<style scoped lang="scss">
    @import "@/stylesheets/Christmas.scss";

    .poll {

        position: relative;

        background-color: $backgroundBlue;

        .chat {
            margin-top: 30px;

            textarea {
                width: calc(100% - 7px);
                height: 200px;
                border-radius: 4px;
                text-align: left;
                margin-top: 10px;
                font-size: 14px;
                resize: none;
            }

            input {
                text-align: left;
                font-size: 16px;
                margin-bottom: 10px;
            }

            label {
                font-size: 16px;
                float: left;
            }
        }

        .chatThanks {
            margin-top: 20px;
        }

        .ground {
            z-index: auto !important;
        }

        .moon {
            height: 15vh;
            max-width: 50vw;
            min-height: 100px;
            position: absolute;
            top: 15vh;
            left: 15%;
            transform: translate(-50%, -50%);
        }

        .stone {
            max-height: 8vh;
            max-width: 5vw;

            position: absolute;
            bottom: $groundHeight;
            left: 10%;
            transform: translateX(-50%);
        }

        .grass {
            width: 80px;
            max-width: 40vw;

            position: absolute;
            bottom: $groundHeight;
            right: 10%;
            transform: translateX(50%);
        }

        .questionContainer {
            position: absolute;
            width: 250px;
            max-width: 80vw;
            top: 40vh;
            left: 50%;
            transform: translate(-50%, -50%);

            &.expanded {
                width: 400px;
                max-width: 80vw;

            }
        }

        .question {
            text-align: center;
            width: 100%;
            font-weight: bold;
            font-size: 1.6em;
            color: black;
            margin-bottom: 60px;
        }

        .radios {
            padding: 0;
        }

        .somethingElse {
            height: 25px;
            border: 1px solid #707070;
            font-weight: normal;
            color: #707070;
            padding-left: 5px;
            padding-right: 5px;
            margin-top: -6px;

            &:hover {
                cursor: text;
            }

            *:hover {
                cursor: text;
            }


        }

        .cButton {
            width: 100px;
            height: 20px;
            border-radius: 10px;
            background-color: #BB3635;
            color: white;
            padding: 8px 20px;
            font-weight: normal;
            text-align: center;
            position: relative;
            margin-top: 60px;
            left: 50%;
            transform: translateX(-50%);
            z-index: 1200;

            &:hover {
                cursor: pointer;
            }

            &.disabled {

                &:hover {
                    cursor: not-allowed;
                }

                background-color: #707070;

            }
        }

        .thanks {
            position: absolute;
            width: 300px;
            max-width: 80vw;
            top: 50vh;
            left: 50%;
            transform: translate(-50%, -50%);
            max-height: 95vh;
            overflow-y: scroll;
            overflow-x: hidden;

            * {
                text-align: center;

            }

            .closeButton {
                width: 200px;
            }
        }

    }

    .mobile {

        .ground {
            height: $groundHeight !important;
        }

    }

</style>

<style lang="scss">
    @import "@/stylesheets/Christmas.scss";

    .textarea {
        resize: none;
        background-color: $backgroundBlue;
        border-radius: 4px;

        height: 20px;
        width: 150px;

        padding-left: 5px;
        padding-right: 5px;

        font-size: 16px;
        font-weight: normal !important;
        color: black;

        &::placeholder {
            font-size: 16px;
            font-weight: normal;
            color: #707070;
        }

        &.selected {
            height: 100px;
            width: 300px;
        }
    }

    .mobile {
        .textarea {
            &.selected {
                width: calc(80vw - 35px);
            }
        }

        .ground {
            z-index: auto !important;
        }
    }
</style>
